module.exports = __webpack_public_path__ + "img/一键美颜--大图--美颜后.b25dfa23.png";